import React, { useEffect, useRef, useState } from "react";
import "./Milestone.css";
import clock from "../../../Asset/wait.gif";
import upwork from "../../../Asset/upwork.png";
import arrow from "../../../Asset/arrow.svg";
import small1 from "../../../Asset/small1.svg";
import small2 from "../../../Asset/small2.svg";
import { Container } from "react-bootstrap";
import clutch from "../../../Asset/clutch.svg";
import google from "../../../Asset/google.png";
import behance from "../../../Asset/behance.png";
import glass from "../../../Asset/glassdor-new.svg";
import fiverr from "../../../Asset/Fiverr_Logo.png";
import stars from "../../../Asset/stars.svg";
import CountUp from "react-countup";

const Milestone = () => {
  const milestoneRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const currentRef = milestoneRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setStartCount(true);
            if (currentRef) observer.unobserve(currentRef);
          }
        });
      },
      { threshold: 0.5 },
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <>
      <section className="milestone-section" ref={milestoneRef}>
        <Container>
          <div className="top-text-after">
            <h2>
              Codeffi <span>MILESTONES</span>
            </h2>
          </div>
          <div className="bottom-part">
            <div className="clock-box">
              <img src={clock} className="clock" alt="clock"></img>
              <h4>
                <strong>1,00,000+ hours</strong> <br />
                recorded on
              </h4>
              <div className="logo-icon">
                <p>
                  <a
                    href="https://www.upwork.com/freelancers/chiragb48"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={upwork} className="upwork" alt="upwork"></img>
                    <img src={arrow} className="arrow" alt="arrow"></img>
                  </a>
                </p>
              </div>
              <span className="last-upwork-text">
                <img src={small1} className="last-text-icon" alt="icon1"></img>
                TOP RATED PLUS
              </span>
              <span className="last-upwork-text">
                <img src={small2} className="last-text-icon" alt="icon2"></img>
                100% JOB SUCCESS
              </span>
            </div>
            <div className="left-cnt-box">
              <div className="mileston-card">
                <div className="counters">
                  <h4 className="first-cnt cnt">
                    {startCount && (
                      <CountUp start={0} end={14} duration={2} suffix="+" />
                    )}
                  </h4>
                  <div className="spacer"></div>
                  <div className="mileston-info">Years in the Space</div>
                </div>
                <div className="counters">
                  <h4 className="second-cnt cnt">
                    {startCount && (
                      <CountUp start={0} end={300} duration={2} suffix="+" />
                    )}
                  </h4>
                  <div className="spacer"></div>
                  <div className="mileston-info">
                    Dreams converted to Reality
                  </div>
                </div>
                <div className="counters">
                  <h4 className="third-cnt cnt">
                    {startCount && (
                      <CountUp start={0} end={90} duration={2} suffix="%" />
                    )}
                  </h4>
                  <div className="spacer"></div>
                  <div className="mileston-info">Client Retention</div>
                </div>
                <div className="counters">
                  <h4 className="fourth-cnt cnt">
                    {startCount && (
                      <CountUp start={0} end={15} duration={2} suffix="+" />
                    )}
                  </h4>
                  <div className="spacer"></div>
                  <div className="mileston-info">Countries Served</div>
                </div>
              </div>

              <div className="mileston-review">
                <span className="review-img-card">
                  <div className="img_text_wrap">
                    <a
                      href="https://clutch.co/profile/codeffi-infotech"
                      target="_blank"
                    >
                      <img alt="card" src={clutch} className="mileston-img" />
                    </a>
                    <div className="rating-sec d-flex align-items-baseline justify-content-center">
                      <span>5.0</span>
                      <img
                        alt="card"
                        src={stars}
                        className="mileston-stars"
                      ></img>
                    </div>
                  </div>
                  <img alt="card" src={arrow} className="mileston-arrow"></img>
                </span>
                <div className="review-divider"></div>

                <span className="review-img-card">
                  <div className="img_text_wrap">
                    <img alt="card" src={google} className="mileston-img"></img>
                    <div className="rating-sec d-flex align-items-baseline justify-content-center">
                      <span>5.0</span>
                      <img
                        alt="card"
                        src={stars}
                        className="mileston-stars"
                      ></img>
                    </div>
                  </div>
                  <img alt="card" src={arrow} className="mileston-arrow"></img>
                </span>
                <div className="review-divider"></div>
                <span className="review-img-card">
                  <div className="img_text_wrap">
                    <img
                      alt="card"
                      src={behance}
                      className="mileston-img"
                    ></img>
                    <div className="rating-sec d-flex align-items-baseline justify-content-center">
                      <span>40+</span>
                      <span className="appreciat">Appreciations</span>
                    </div>
                  </div>
                  <img alt="card" src={arrow} className="mileston-arrow"></img>
                </span>
                <div className="review-divider"></div>
                <span className="review-img-card">
                  <div className="img_text_wrap">
                    <img alt="card" src={glass} className="mileston-img"></img>
                    <div className="rating-sec d-flex align-items-baseline justify-content-center">
                      <span>4.6</span>
                      <img
                        alt="card"
                        src={stars}
                        className="mileston-stars"
                      ></img>
                    </div>
                  </div>
                  <img alt="card" src={arrow} className="mileston-arrow"></img>
                </span>
                <div className="review-divider"></div>

                <span className="review-img-card">
                  <div className="img_text_wrap">
                    <img alt="card" src={fiverr} className="mileston-img"></img>
                    <div className="rating-sec">
                      <span>5.0</span>
                      <img
                        alt="card"
                        src={stars}
                        className="mileston-stars"
                      ></img>
                    </div>
                  </div>
                  <img alt="card" src={arrow} className="mileston-arrow"></img>
                </span>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Milestone;
